<div class="full-container">

  <!-- LEFT SIDE -->
  <div class="left-side">
    <form [formGroup]="assignmentForm">

      <label class="form-label mb-2">Select Employees</label>

      <!-- Search box -->
      <input
        type="text"
        class="form-control"
        placeholder="Type at least 3 characters to search"
        formControlName="employeeSearch" />

      <!-- Search results dropdown -->
      <div
        class="list-group mt-2"
        *ngIf="employeeResults.length > 0">

        <button
          type="button"
          class="list-group-item list-group-item-action"
          *ngFor="let emp of employeeResults"
          (click)="addEmployee(emp)">
          {{ emp.fullName }} ({{ emp.employeeCode }})
        </button>

      </div>

    </form>

    <div
      class="mt-3 d-flex flex-wrap gap-2"
      *ngIf="assignmentForm.value.selectedEmployees.length">

  <span
    class="badge bg-primary d-flex align-items-center px-3 py-2"
    *ngFor="let emp of assignmentForm.value.selectedEmployees">

    {{ emp.display }}

    <i
      class="ms-2 fas fa-times cursor-pointer"
      (click)="removeEmployee(emp)">
    </i>
  </span>

    </div>
    <!-- =========================
         COMPANY SELECTION (READ-ONLY)
    ========================== -->

    <div class="row mt-4" *ngIf="company$ | async as company">
      <label class="form-label mb-2">Company Selection</label>

      <div class="toggle-block mb-4 text-center">

        <label class="d-block mb-2">
          {{ company.name }}
        </label>

        <div class="custm-toglbtn small-toggle mx-auto">
          <input type="checkbox" checked disabled>
          <label></label>
        </div>
      </div>
    </div>

    <!-- =========================
         ENTITY SELECTION (READ-ONLY)
    ========================== -->

    <div class="row" *ngIf="entities$ | async as entities">
      <label class="form-label mb-2">Entity Selection</label>

      <div class="col-md-6 mb-4" *ngFor="let ent of entities">

        <div class="toggle-block text-center">

          <label class="d-block mb-2">
            {{ ent.name }}
          </label>

          <div class="custm-toglbtn small-toggle mx-auto">
            <input type="checkbox" checked disabled>
            <label></label>
          </div>

        </div>

      </div>
    </div>

    <!-- =========================
         ACTION BUTTONS
    ========================== -->

    <button
      class="btn btn-primary mt-4"
      (click)="saveAssignment()"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title="By clicking this, admin access will be provided to the selected employees.">
      Provide Admin Access
    </button>

    <button
      class="btn btn-outline-secondary mt-4 ms-2"
      (click)="goImport.emit()">
      Add More Employees
    </button>

  </div>

  <!-- =========================
       RIGHT SIDE – HISTORY PANEL
  ========================== -->

  <div class="right-side">

    <h5 class="side-panel-label">
      Admin Assignment History
    </h5>

    <div class="admin-card-list">

      <div class="admin-card" *ngFor="let emp of history">

        <div class="admin-card-header">
          <div class="emp-name">{{ emp.name }}</div>
        </div>

        <div class="admin-card-body">

          <div class="row-line mt-2">
            <span class="form-label">Company Admin:</span>
            <span
              class="value"
              [class.yes]="emp.companyAdmin">
              {{ emp.companyAdmin ? 'Yes' : 'No' }}
            </span>
          </div>

          <div class="row-line mt-2">
            <span class="form-label">Entities:</span>
          </div>

          <div class="entity-list">
            <div
              class="entity-item"
              *ngFor="let e of emp.entities">
              • {{ e }}
            </div>

            <div
              *ngIf="emp.entities.length === 0"
              class="none">
              None
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>

<!-- =========================
     WIZARD FOOTER
========================== -->

<div class="wizard-footer mt-4 d-flex justify-content-end">
  <button
    class="btn btn-primary"
    (click)="onSaveAndNext()">
    Save & Next
  </button>
</div>
